import { app } from '../../../../../app';
import { Controller } from './add-remote-app.controller';

app.component('companyManageApplicationRemoteAppAdd', {
    bindings: {
        appId: '<',
        companyId: '<',
        application: '<',
        remoteApps: '=',
    },
    controller: Controller,
    templateUrl: require('./add-remote-app.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/add/add-remote-app.component.js